import { LanguageProvider, useLanguage } from './hooks/useLanguage';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import DeliveryPartners from './components/DeliveryPartners';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import Inscription from './pages/Inscription';
import LegalPage from './pages/LegalPage';

function Landing() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash || window.location.hash;
    if (hash) {
      // Small delay to ensure all components are rendered
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 400);
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <DeliveryPartners />
      <Pricing />
      <Footer />
    </>
  );
}

function AppContent() {
  const { dir, isRTL } = useLanguage();

  return (
    <div dir={dir} className={`min-h-screen bg-dark-900 ${isRTL ? 'font-arabic' : 'font-sans'}`}>
      <Routes>
        <Route path="/" element={<Inscription />} />
        <Route path="/home" element={<Landing />} />
        <Route path="/privacy-policy" element={<LegalPage page="privacy" />} />
        <Route path="/data-deletion" element={<LegalPage page="dataDeletion" />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
